
import { useTranslation } from 'react-i18next';

export default function WhyChooseSection() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-global-line',
      titleKey: 'value_global_network',
      descKey: 'value_global_network_desc',
      image: '/resources/global-network-001.jpg'
    },
    {
      icon: 'ri-rocket-line',
      titleKey: 'value_integrated_marketing',
      descKey: 'value_integrated_marketing_desc',
      image: '/resources/integrated-marketing-001.jpg'
    },
    {
      icon: 'ri-bar-chart-line',
      titleKey: 'value_transparent_data',
      descKey: 'value_transparent_data_desc',
      image: '/resources/data-reporting-001.jpg'
    },
    {
      icon: 'ri-lightbulb-line',
      titleKey: 'value_category_expertise',
      descKey: 'value_category_expertise_desc',
      image: '/resources/expertise-001.jpg'
    },
    {
      icon: 'ri-time-line',
      titleKey: 'value_fast_execution',
      descKey: 'value_fast_execution_desc',
      image: '/resources/fast-execution-001.jpg'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('value_title')}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('value_subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.slice(0, 3).map((feature, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
              <div className="relative overflow-hidden">
                <img 
                  src={feature.image}
                  alt={t(feature.titleKey)}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {t(feature.titleKey)}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {t(feature.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-8 mt-8">
          {features.slice(3).map((feature, index) => (
            <div key={index + 3} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
              <div className="relative overflow-hidden">
                <img 
                  src={feature.image}
                  alt={t(feature.titleKey)}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {t(feature.titleKey)}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {t(feature.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
